import React, { useState, useMemo } from 'react';
import {
  ReceiptLong as ReceiptLongIcon,
  AddTask as AddTaskIcon,
  ContactMail as ContactMailIcon,
  Replay as ReplayIcon,
  CreditScore as CreditScoreIcon,
  Rowing as RowingIcon,
  Person,
  AccountBalance as DepartmentIcon,
} from '@mui/icons-material';
import ApprovalIcon from '@mui/icons-material/Approval';
import PaymentsIcon from '@mui/icons-material/Payments';

import DepartmentLayout from '../Layout/DepartmentLayout';
import Home from './Home';
import PatientBill from './PatientBill';
import PatientInformation from './PatientInformation';
import UserAccount from './UserAccount';
import Debtor from './Debtor';
import ReversalRequest from './ReversalRequest';
import BillMe from './BillMe';
import PettyExpenses from './PettyExpenses';
import ExpenseApproval from './ExpenseApproval';

export default function Accounts() {
  // Shared state — PatientInformation calls onEditPatient with patient data,
  // we navigate to PatientBill which reads selectedPatient.
  const [selectedPatient, setSelectedPatient] = useState(null);

  const menuItems = useMemo(() => [
    { key: 'Home', label: 'Home', icon: <ReceiptLongIcon />, component: Home },
    {
      key: 'PatientInformation',
      label: 'Patient Information',
      icon: <ContactMailIcon />,
      render: ({ navigate }) => (
        <PatientInformation
          onEditPatient={(p) => {
            setSelectedPatient(p);
            navigate('PatientBill');
          }}
        />
      ),
    },
    {
      key: 'PatientBill',
      label: 'Patient Bill',
      icon: <AddTaskIcon />,
      render: () => <PatientBill selectedPatient={selectedPatient} />,
    },
    { key: 'ReversalRequest', label: 'Transaction Reversal',  icon: <ReplayIcon />,      component: ReversalRequest },
    { key: 'UserAccount',     label: 'Accounts Balancing',    icon: <CreditScoreIcon />, component: UserAccount },
    { key: 'Debtor',          label: 'Debtor (Patient/Client)', icon: <RowingIcon />,    component: Debtor },
    { key: 'BillMe',          label: 'Bill Me',               icon: <Person />,          component: BillMe },
    { key: 'PettyExpenses',   label: 'Petty Expenses',        icon: <PaymentsIcon />,    component: PettyExpenses },
    { key: 'ExpenseApproval', label: 'Expense Approval',      icon: <ApprovalIcon />,    component: ExpenseApproval },
  ], [selectedPatient]);

  return (
    <DepartmentLayout
      departmentId={25}
      departmentName="Billing & Accounts"
      departmentIcon={<DepartmentIcon />}
      menuItems={menuItems}
    />
  );
}
